// Action Types
export const UPLOAD_MANAGER_ADD = 'UPLOAD_MANAGER_ADD'
export const UPLOAD_MANAGER_REMOVE = 'UPLOAD_MANAGER_REMOVE'
export const UPLOAD_MANAGER_SET_AUTO_REMOVAL = 'UPLOAD_MANAGER_SET_AUTO_REMOVAL'
